import React from 'react'
import { FormattedMessage } from 'react-intl'

type BestPlanInfoProps = {
  selected?: boolean
}

export default function BestPlanInfo({ selected = true }: BestPlanInfoProps) {
  return (
    <div
      className={`
        absolute right-[5px] top-[5px] 
        z-20 transform text-center md:right-[12px]
        md:top-[12px] 
        md:mr-0 
        md:translate-x-0`}
    >
      <span
        className={`
        z-20 whitespace-nowrap
        rounded-20 px-12
        ${selected ? 'py-6 lg:py-8' : 'py-4 lg:py-6'}
        text-black type-14-demibold lg:px-16
        ${selected ? 'bg-green-electric' : 'bg-beige-muted'}
      `}
      >
        <span className="relative z-20">
          <FormattedMessage
            defaultMessage="Most popular"
            id="chooseSubscription.mostPopular"
          />
        </span>
      </span>
    </div>
  )
}
